import React from 'react'
import styled from 'styled-components'

import { QA } from '@hozana/tests/constants'

import { ALERT_COLORS } from 'elements/constants'
import type { TBorderedDivProps } from 'elements/layout/BorderedDiv'
import { BorderedSpan } from 'elements/layout/BorderedSpan'
import { TTextProps, Text } from 'elements/text/Text'

export const StyledBorderedSpan = styled(BorderedSpan)`
  align-self: flex-start;
  line-height: 1em;
`

export type TLabelProps = {
  colors?: keyof typeof ALERT_COLORS
} & Pick<TTextProps, 'fontSize' | 'lineHeight'> &
  TBorderedDivProps

export const Label: TFCC<TLabelProps> = ({ colors, children, fontSize = '1em', lineHeight = '1em', ...otherProps }) => (
  <StyledBorderedSpan borderColor={ALERT_COLORS[colors].bg} bg={ALERT_COLORS[colors].bg} p="2px 4px" {...otherProps}>
    <Text
      data-testid={QA.COMMUNITIES_PAGE.LABEL}
      fontSize={fontSize}
      lineHeight={lineHeight}
      color={ALERT_COLORS[colors].color}
      firstUpper
      vAlign="unset"
    >
      {children}
    </Text>
  </StyledBorderedSpan>
)
